export const GET_PROFESSIONS: string = "GET_PROFESSIONS";
export const GET_PROFESSIONS_CATEGORIES: string = "GET_PROFESSIONS_CATEGORIES";
export const GET_PROFESSION: string = "GET_PROFESSION";
export const FILTER_PROFESSIONS: string = "FILTER_PROFESSIONS";
export const TOGGLE_PROFESSION_CATEGORY: string = "TOGGLE_PROFESSION_CATEGORY";
export const RESET_PROFESSION: string = "RESET_PROFESSION";
export const TOGGLE_PROFESSION_EDITING: string = "TOGGLE_PROFESSION_EDITING";
export const RESET_TOGGLE_PROFESSION_EDITING: string = "RESET_TOGGLE_PROFESSION_EDITING";
export const EDIT_PROFESSION_FIELD: string = "EDIT_PROFESSION_FIELD";
export const RESET_EDIT_PROFESSION_FIELDS: string = "RESET_EDIT_PROFESSION_FIELDS";
export const NEW_PROFESSION_FIELD: string = "NEW_PROFESSION_FIELD";
export const RESET_NEW_PROFESSION_FIELDS: string = "RESET_NEW_PROFESSION_FIELDS";
export const SEND_NEW_PROFESSION: string = "SEND_NEW_PROFESSION";
export const SEND_EDIT_PROFESSION: string = "SEND_EDIT_PROFESSION";
export const DELETE_PROFESSION: string = "DELETE_PROFESSION";
